import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "../api/client.ts";

interface Integration {
  id: string;
  kind: string;
  enabled: boolean;
  non_secret_config: Record<string, unknown>;
  health_status: string;
  health_message: string | null;
  last_checked_at: string | null;
  has_secret: boolean;
}

export default function IntegrationsPage() {
  const { data } = useQuery({ queryKey: ["integrations"], queryFn: () => apiFetch<Integration[]>("/integrations") });
  const kinds = ["twilio", "claude", "mapbox", "google_calendar", "quickbooks", "zapier", "campaign_manager", "slack", "gbp"];
  const byKind = new Map(data?.map((i) => [i.kind, i]));
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold text-slate-900">Integrations</h1>
      <div className="grid gap-3 md:grid-cols-2">
        {kinds.map((k) => {
          const i = byKind.get(k);
          return (
            <div key={k} className="card">
              <div className="flex items-center justify-between">
                <h3 className="font-semibold capitalize">{k.replace(/_/g, " ")}</h3>
                <span className={`rounded px-2 py-0.5 text-xs ${i?.enabled ? "bg-emerald-100 text-emerald-700" : "bg-slate-100 text-slate-600"}`}>
                  {i?.enabled ? "enabled" : "not configured"}
                </span>
              </div>
              <div className="mt-2 text-xs text-slate-500">
                Health: {i?.health_status ?? "unknown"} {i?.last_checked_at && `· checked ${new Date(i.last_checked_at).toLocaleString()}`}
              </div>
              {k === "twilio" && (
                <a href="/integrations/twilio" className="mt-2 inline-block text-sm text-brand-700 hover:underline">
                  Configure Twilio →
                </a>
              )}
              <p className="mt-2 text-sm text-slate-600">
                {k === "twilio" && "Phase 3: calls, SMS, voicemail, click-to-call, IVR."}
                {k === "claude" && "Phase 4: call transcription, triage, chatbot, suggested replies."}
                {k === "mapbox" && "Phase 2: live tech map, route optimization, ETAs."}
                {k === "google_calendar" && "Phase 5: 2-way calendar sync per technician."}
                {k === "quickbooks" && "Phase 5: export customers + invoices."}
                {k === "zapier" && "Phase 5: outbound webhook hub (normalized events)."}
                {k === "campaign_manager" && "Phase 5: close-the-loop ROI attribution with Campaign Manager."}
                {k === "slack" && "Phase 5: alert channels for oncall + SLA escalations."}
                {k === "gbp" && "Phase 5: Google Business Profile review automation."}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
